import React from 'react'
import "jquery/dist/jquery.min";
import "bootstrap/dist/js/bootstrap.min";
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import arlug_logo from '../../../assets/images/arlug_logo.png'
import styles from './navbar.module.scss';

export default function Navbar(props) {

    let menuItems = [];
    if (props.userType === "arlug_client") {
        menuItems = [
            {
                label: (
                    <div className="leftLogo">
                        <img src={arlug_logo} alt="Arlug Logo" width="145px" style={{position:'absolute', top: 15, height: '40px'}} />
                    </div>
                ),
                key: 'arlugLogo',
            },
            {
                label: (
                    <div className="rightLogo">
                        <Link to={props.landingPage} children={<img src={'logo.png'} alt="Everlink Logo" width="160px" />} />
                    </div>
                ),
                key: 'everlink',
                className: 'menuBrand'
            },
        ];
    } else {
        menuItems = [
            {
                label: <Link to={props.landingPage} children={<img src={'logo.png'} alt="Everlink Logo" width="160px" />} />,
                key: 'everlink',
                className: 'menuBrand'
            },
        ]
    }

    return (
        <Menu theme="dark" className={styles['navBarCustom']} mode="horizontal" selectable={false} items={props.isUserAuthenticated ? menuItems : []}>
        </Menu>
    );
}